import { SharedStyle, track } from '@tldraw/tldraw'
import { ButtonProps } from 'blaze-components/WriterTopBar/Types'
import { Button } from 'common/Prose/Toolbar/ToolbarBravo/WriterFormatToolbar/Button'
import { forwardRef } from 'react'

interface StyleToggleButtonProps extends Omit<ButtonProps, 'onPress'> {
  style: SharedStyle<boolean>
  onPress: (newValue: boolean) => any
}

export const StyleToggleButton = track(
  forwardRef<HTMLButtonElement, StyleToggleButtonProps>(({ style, onPress, ...rest }, fRef) => {
    return (
      <Button
        {...rest}
        ref={fRef}
        variant={style.type === 'mixed' || style.value === true ? 'squareToggleOn' : 'squareToggleOff'}
        onPress={() => onPress(style.type === 'mixed' || style.value === false ? true : false)}
      />
    )
  }),
)
